const translations = {
    DATE: "日期",
    TIME: "時間",
    HKD: "港元",
    RMB: "人民幣",
    USD: "美元",
    SGD: "新元",
    CNY: "人民幣",
    JPY: "港元",
    MARKET_PRICE: "市場價格",
    PREVIOUS_CLOSE: "上日收市",
    AS_OF: "截至",
};
export default translations;